// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"94":"06ceb1fb4434c7e49f74","239":"213ebaf211e879d2d304","385":"a78c9a1b231af3744503","644":"852d4ad6643ab418e361","937":"db0e08298a992bc47b3b","994":"c90246d6f3555cf7f888"}[chunkId] + ".chunk.js";
};